import React from 'react';
import { useQuery } from '@apollo/client';
import { DefaultMeta } from 'src/components/AppShell/Head';
import { useDeps } from 'src/hooks/useDeps';
import { useSetPopupPageCategory } from 'src/components/PopupBanner/PopupPageContext';
import { useSetResolved } from 'src/core/engine/router/useSetResolved';
import { CategoryRootSkeleton } from 'src/elements/Skeletons/Skeletons';
import { Container, Wrapper } from 'src/components/Layout';

import { CategoryBrandPage } from '../../components/CategoryBrandPage/CategoryBrandPage';
import { ErrorOrOfflineConnected } from '../../components/Error/ErrorOrOffline';
import categoryListQuery from '../../queries/categoryList.graphql';
import {
    categoryList,
    categoryList_categoryList_children,
    categoryListVariables,
} from '../../queries/__generated__/categoryList';
import { cleanBrands } from '../../components/CategoryBrandPage/utils/utils';

import '../../scss/_root-component.scss';

type Props = {
    id: number;
    pathname: string;
};

const EMPTY_PARENT_IDS: number[] = [];

export const CategoryBrandRoot: React.FC<Props> = ({ id }) => {
    useSetPopupPageCategory(id, EMPTY_PARENT_IDS);
    useSetResolved();

    const { loading, error, data } = useQuery<categoryList, categoryListVariables>(categoryListQuery, {
        variables: { id: id },
        ssr: useDeps().env.SSR_GQL,
    });

    if (error) return <ErrorOrOfflineConnected message={`Data fetch error ${error}`} />;
    if (loading || !data)
        return (
            <Wrapper element="section" variant="widget-wrapper">
                <Container>
                    <CategoryRootSkeleton />
                </Container>
            </Wrapper>
        );
    if (!data.categoryList) return null;
    if (!data.categoryList.children) return null;

    const { name, meta_title, meta_description } = data.categoryList;
    const brands = data.categoryList.children;
    const meta = {
        title: meta_title || name || 'unknown',
        description: meta_description || name || 'unknown',
    };

    return (
        <>
            <DefaultMeta data={meta} withoutPrefix />
            <CategoryBrandPage brands={cleanBrands(brands as categoryList_categoryList_children[])} />
        </>
    );
};

export default CategoryBrandRoot;
